'use client';

import {
  currentServiceAtom,
  Services,
} from '@store/CurrentService/currentService';
import {useHydrateAtoms} from 'jotai/react/utils';
import {memo} from 'react';

export const HydrateCurrentService = memo<{service: Services}>(({service}) => {
  useHydrateAtoms([[currentServiceAtom, service]]);
  return null;
});
